import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';
import { MevCredentialsInputDTORuntype, MevResponseBodyDTORuntype } from './mevBackendTypes';

export const mevEndpoints = {
    'GET /3rdparty/mev/credentials': endpoint({
        description: 'Returns credentials for MEV Elektronik integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: MevResponseBodyDTORuntype,
    }),
    'POST /3rdparty/mev/credentials': endpoint({
        description: 'Uploads credentials for MEV Elektronik API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: MevCredentialsInputDTORuntype,
        responseBody: MevResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/mev/credentials'],
    }),
    'PATCH /3rdparty/mev/credentials': endpoint({
        description: 'Updates credentials for MEV Elektronik API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: MevCredentialsInputDTORuntype,
        responseBody: MevResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/mev/credentials'],
    }),
    'DELETE /3rdparty/mev/credentials': endpoint({
        description: 'Deletes existing credentials for MEV Elektronik API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.object({ deleted: z.number() }),
        invalidates: ['GET /3rdparty/mev/credentials'],
    }),
};
